import * as Yup from "yup";

export const accreditationSchema = Yup.object().shape({
  name: Yup.string().required("Name field cannot be empty"),
  // license: Yup.string().required("License field cannot be empty"),
  membership_status: Yup.string().required(
    "Membership Status field cannot be empty"
  ),
  date_awarded: Yup.string().required("Date Awarded field cannot be empty"),
  accrediting_body_id: Yup.string().required("Accrediting Body is required"),
  institution_id: Yup.string().required("Institution is required"),
});
